import { bsrmAppServiceApi } from "../../../app/bsrm/bsrmAppServiceApi";
import { BASE_API_BSRM } from "../../../constants/apiUrl";
import { GetQueryArgsType } from "../../../types";

import {
  GetAllSupplierPartiesParams,
  GetAllSupplierPartiesResponseType,
  GetDealerListParams,
  GetDealerListResponseType,
} from "../../../types/bsrm/dealer.type";

export const dealerApi = bsrmAppServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getDealerList: builder.query<
      GetDealerListResponseType,
      GetDealerListParams
    >({
      query: (queries) => {
        // console.log(queries);
        return {
          url: BASE_API_BSRM.getDealerList,
          params: { ...queries },
        };
      },
    }),

    getAllSupplierParties: builder.query<
      GetAllSupplierPartiesResponseType,
      GetQueryArgsType<GetAllSupplierPartiesParams>
    >({
      query: (queryArgs) => ({
        url: BASE_API_BSRM.getAllSupplierParties,
        ...queryArgs,
      }),
      // providesTags: ["GetAllSupplierParties"],
    }),
  }),
});

export const { useGetDealerListQuery, useGetAllSupplierPartiesQuery } =
  dealerApi;
